import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import {
  canSelectAgencyCategory,
  getAgencyCategoryOptions,
  resolveAgencyCategoryIds,
  toggleAgencyCategory,
} from './agencyCategorySelection';

const labels = {
  'Non résidents Standard': 'Non-résidents Standard',
  'Non résidents Premium': 'Non-résidents Premium',
};

const MultiSelectCategories = ({ value = null, onValueChange, categories }) => {
  const options = getAgencyCategoryOptions(categories);
  const selectedIds = resolveAgencyCategoryIds(value, categories);

  return (
    <div role="group" aria-label="Catégories proposées" className="flex flex-nowrap gap-1 overflow-hidden">
      {options.map((category) => {
        const selected = selectedIds.includes(category.id);
        return (
          <button
            key={category.id}
            type="button"
            aria-pressed={selected}
            disabled={!selected && !canSelectAgencyCategory(category, categories)}
            onClick={() => onValueChange(toggleAgencyCategory(value, category, categories))}
            className={`inline-flex min-h-9 shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-[7px] text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${
              selected
                ? 'border-[#9cc5ab] bg-[#f4fbf6] text-[#206a42]'
                : 'border-[#d6e0d9] bg-white text-[#6d7d72] hover:border-[#8bad97]'
            }`}
          >
            {selected && <Check aria-hidden="true" className="h-3.5 w-3.5" />}
            {labels[category.name] || category.name}
          </button>
        );
      })}
    </div>
  );
};

MultiSelectCategories.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onValueChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })).isRequired,
};

export default MultiSelectCategories;
